import React from "react";
import AddItem from "../../../../common/components/shared/addItem/addItem";
import i18n from "../../../../i18n/i18n";
import LocationForm from "../locationForm/locationForm";

export default class AddLocation extends React.Component {
    render() {
        return (
            <AddItem
                class="add-location"
                header={i18n.t("topology.locations.actions.addLocation.header")}
                content={<LocationForm isUpdate={false}/>}
            />
        );
    }
}